<template>
  <div class="home">
    <div class="content">
      <!-- body部分 -->
      <div class="contentA clearfix">
        <div class="vedio left fl">
          <video
            id="my-video"
            class="video-js"
            controls
            width="694"
            height="520"
            poster="@/assets/video/jjspPic.png"
            data-setup="{}"
          >
            <source
              src="@/assets/video/hnhyjjsp.mp4"
              type="video/mp4"
            />
          </video>
    
        </div>
    
        <div class="right fr">
          <h3>项目简介</h3>
          <span>PROJECT PROFILE</span>
          <p style="text-align: JUSTIFY; height: 190px">
            珊瑚礁生态系统是地球上生物多样性最高的生态系统之一，被誉为“海洋中的热带雨林”。虽然珊瑚礁海域仅占全球海洋总面积的0.1%，却为高达25%的海洋生物物种提供栖息地和繁衍场所。当前，由于气候变暖、海洋酸化、人类活动影响不断加剧，导致...
          </p>
          <router-link to="/about">查看更多>></router-link>
        </div>
      </div>
    
      <div class="contentB">
        <div class="title">
          <h3>实验项目相关信息</h3>
          <span>INFORMATION </span>
        </div>
        <ul class="accessories clearfix">
          <li 
            v-for="(item, index) in ['实验原理', '实验教学方法', '实验方法与步骤', '结果与讨论要求', '实验考核要求', '面向学生要求']" :key="index">
            <router-link 
              :to="`/info?id=${index+1}&type=1`">
              <span :class="`icon${index+1}`"></span>{{ item }}
            </router-link>
          </li>
        </ul>
      </div>
    
      <div class="contentC">
        <div class="column-content clearfix">
          <div class="vedio-player">
            <video
              id="my-video1"
              class="video-js"
              controls
              width="525"
              height="360"
              poster="@/assets/video/ydspPic.png"
              data-setup="{}"
            >
              <source
                src="@/assets/video/hnhyydsp.mp4"
                type="video/mp4"
              />
            </video>
          </div>
    
          <div class="exp-detail">
            <div class="title">
              <h3>实验项目相关信息</h3>
              <span>INFORMATION</span>
            </div>
            <p class="detail-info">
              <span>所属分类：海洋科学</span>
              <span>实验学时：4</span>
              <span>实验操作步数：15</span>
            </p>
            <p class="detail-info">
              <span>实验项目负责人：陈骁</span>
              <span>联系电话：13922104624</span>
            </p>
            <p class="detail-info" style="width: 496px">
              实验简介：本实验含珊瑚礁生态系统调查的5个关键环节、15个步骤，虚拟仿真完整的珊瑚礁出海调查流程，拓宽知识体系。
            </p>
            <p class="start-exp lang-text clearfix">
              <a href="http://120.79.82.49:8880/sufen/coralreef.rar" class="into-exp">评审入口</a>
              <a href="http://120.79.82.49:8880/sufen/coralreef.rar" style="margin-left: 15px" class="ilab-exp">教学入口</a>
            </p>
          </div>
        </div>
      </div>
    
      <section class="contentD">
        <div class="title">
          <h3>实验教学服务团队</h3>
          <span>SERVICE TREAM </span>
        </div>
        <div class="layBox">
          <div class="ladyScroll">
            <a class="prev" href="javascript:;"></a>
            <div class="scrollWrap">/
              <div class="dlList">
                <dl v-for="(item, index) in 5" :key="index">
                  <dt>
                    <a href="javascript:;"
                      ><img
                        :src="require(`@/assets/picture/${index%8+1}.gif`)"
                    /></a>
                  </dt>
                  <dd>
                    <div v-if = "index == '0'"> 
                      <a href="javascript:;">
                        <p class="name">陈骁</p>
                        <div class="tea">教授</div>
                      </a>
                    </div>
                    <div v-if = "index == '1'"> 
                      <a href="javascript:;">
                        <p class="name">孙际佳</p>
                        <div class="tea">高级实验师</div>
                      </a>
                    </div>
                    <div v-if = "index == '2'"> 
                      <a href="javascript:;">
                        <p class="name">张晓勇</p>
                        <div class="tea">副教授</div>
                      </a>
                    </div>
                    <div v-if = "index == '3'"> 
                      <a href="javascript:;">
                        <p class="name">于宗赫</p>
                        <div class="tea">副教授</div>
                      </a>
                    </div>
                    <div v-if = "index == '4'"> 
                      <a href="javascript:;">
                        <p class="name">何玉慧</p>
                        <div class="tea">实验师</div>
                      </a>
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
            <a class="next" href="javascript:;"></a>
          </div>
          
        </div>
      </section>
      <section class="contentE">
        <div class="title">
          <h3>网络项目共享情况</h3>
          <span>PROJECT SHARING</span>
        </div>
        <div class="bottom clearfix">
          <div class="echart fl">
            <div id="usageWeek" style="width: 100%; height: 100%"></div>
          </div>
          <div class="fr amount">
            <p class="clearfix">
              <a href="javascript:;" class="fl"><span></span>项目使用量</a>
              <a href="javascript:;" class="fr"
                ><span style="background: #2267e9"></span>项目浏览量</a
              >
            </p>
            <div class="all">
              <span>总使用量：</span>
              <a class="num all-usage">{{ formTotal.use }}</a>
            </div>
            <div class="all" style="background-color: #2267e9">
              <span>总浏览量：</span>
              <a class="num all-browsing">{{ formTotal.look }}</a>
            </div>
          </div>
        </div>
      </section>
      <section class="contentF clearfix">
        <div class="left squr fl">
          <span>项目架构及研发技术</span>
          <div>
            <h3>项目架构及研发技术</h3>
            <ul>
              <li><a href="#/info?id=2">系统架构图及简要说明</a></li>
              <li><a href="#/info?id=2">实验教学项目</a></li>
            </ul>
          </div>
        </div>
    
        <div class="center squr fl">
          <span>项目特色</span>
          <div>
            <h3>项目特色</h3>
            <ul>
              <li><a href="#/info?id=3">实验方案设计思路</a></li>
              <li><a href="#/info?id=3">教学方法创新</a></li>
              <li><a href="#/info?id=3">评价体系创新</a></li>
              <li><a href="#/info?id=3">对传统教学的延伸与拓...</a></li>
            </ul>
          </div>
        </div>
    
        <div class="right squr fl">
          <span>持续建设服务计划</span>
          <div>
            <h3>持续建设服务计划</h3>
            <ul>
              <li><a href="#/info?id=4">课程持续建设</a></li>
              <li><a href="#/info?id=4">面向高校、社会的教学推广应用计划</a></li>
            </ul>
          </div>
        </div>
      </section>
    
      <section class="contentG">
        <div class="title">
          <h3>网络相关需求</h3>
          <span>DEMAND</span>
        </div>
        <ul class="clearfix">
          <li class="g1"><a href="#/info?id=1">有效链接网址</a></li>
          <li class="g2"><a href="#/info?id=1">网络条件要求</a></li>
          <li class="g3"><a href="#/info?id=1">用户操作系统要求</a></li>
          <li class="g4"><a href="#/info?id=1">用户非操作系统软件配...</a></li>
          <li class="g5"><a href="#/info?id=1">用户硬件配置要求</a></li>
          <li class="g6"><a href="#/info?id=1">用户特殊外置硬件要求</a></li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  components: {
  },
  data () {
    return {
      formTotal: {
        use: '-',
        look: '-'
      }
    }
  },
  mounted () {
    this.startTeam()
    // this.getEcharts()
    this.getData()
    this.getInfo()
  },
  methods: {
    startTeam () {
      window && 
      window.jQuery(".ladyScroll")
      .slide({ mainCell:".dlList", effect:"leftLoop",vis:4, autoPlay:true});
    },
    getInfo () {
      window.jQuery.ajax({
        url: this.$baseUrl + '/HuanongSeaSurvey/visitLog/findDAUorPV',
        type: 'GET',
        success: (res) => {
          console.log(res)
          this.formTotal.use = res.data.DAU
          this.formTotal.look = res.data.PV
        }
      })
    },
    getData () {
      window.jQuery.ajax({
        url: this.$baseUrl + '/HuanongSeaSurvey/visitLog/find7DaysPV',
        type: 'GET',
        success: ({ data: PVDATA }) => {
          var usageWeek = window.echarts.init(document.getElementById('usageWeek'));
          usageWeek.showLoading();
          window.jQuery.ajax({
            url: this.$baseUrl + '/HuanongSeaSurvey/visitLog/find7DaysDAU',
            type: 'GET',
            success: ({ data: DAUDATA }) => {
              console.log(PVDATA, DAUDATA)
              var usageOption = {
                  tooltip: {
                      trigger: 'axis',
                      axisPointer: {
                          type: 'cross',
                          crossStyle: {
                              color: '#999'
                          }
                      }
                  },
                  grid: {
                      left: '3%',
                      right: '4%',
                      bottom: '3%',
                      containLabel: true
                  },
                  legend: {
                      data:['实验项目使用量','实验项目浏览量'],
                      right:'3%',
                      top:'1%',
                      show:false
                  },
                  xAxis: [

                      {	splitLine:{show: false},//去除网格线
                          type: 'category',
                          data: DAUDATA.dates,
                          axisPointer: {
                              type: 'shadow'
                          }
                      }
                  ],
                  yAxis: [
                      {	splitLine:{show: false},//去除网格线
                          type: 'value'
                      }
                  ],
                  series: [
                      {
                          name:'实验项目使用量',
                          type:'bar',
                          barWidth : 15,//柱图宽度
                          data: DAUDATA.counts,
                          itemStyle: {
                      normal: {
                        color: '#dc9b00'
                      }
                    }
                      },
                      {
                          name:'实验项目浏览量',
                          type:'bar',
                          barWidth : 15,//柱图宽度
                          data:PVDATA.counts,
                          itemStyle: {
                      normal: {
                        color: '#2267e9'
                      }
                    }
                      }
                  ]
              };
              usageWeek.hideLoading();
              usageWeek.setOption(usageOption);
            }
          })
        }
      })
    },
    getEcharts () {
      window.jQuery.getJSON("/api/virexp/shared_platform/resources/!browsingRecod?id=ff8080816b7449eb016c07ee68e06991",function(data){
        if (data==true) {
        var usageWeek = window.echarts.init(document.getElementById('usageWeek'));
        usageWeek.showLoading();

        window.jQuery.getJSON("/api/virexp/shared_platform/statistics/!single?experimentId=ff8080816b7449eb016c07ee68e06991",function(data){
            // console.log(data)
            var weeks = data;
            var xWeeks = [];
            var weeksBrowsing = [];
            var weeksUsage = [];

            // window.$('.all-usage').html(weeks.usage_num+952);
            // window.$('.all-browsing').html(weeks.browsing_num+1452);

            var use = [21,25,30,19,22,27,24]
            var bow = [35,48,33,31,27,40,36]

            var i=0;
            for(var w in weeks.browsing_json) {
                xWeeks.push(w);
                weeksBrowsing.push(weeks.browsing_json[w]+bow[i])
                weeksUsage.push(weeks.usage_json[w]+use[i])
                i++
            }
          var usageOption = {
              tooltip: {
                  trigger: 'axis',
                  axisPointer: {
                      type: 'cross',
                      crossStyle: {
                          color: '#999'
                      }
                  }
              },
              grid: {
                  left: '3%',
                  right: '4%',
                  bottom: '3%',
                  containLabel: true
              },
              legend: {
                  data:['实验项目使用量','实验项目浏览量'],
                  right:'3%',
                  top:'1%',
                  show:false
              },
              xAxis: [

                  {	splitLine:{show: false},//去除网格线
                      type: 'category',
                      data: xWeeks,
                      axisPointer: {
                          type: 'shadow'
                      }
                  }
              ],
              yAxis: [
                  {	splitLine:{show: false},//去除网格线
                      type: 'value'
                  }
              ],
              series: [
                  {
                      name:'实验项目使用量',
                      type:'bar',
                      barWidth : 15,//柱图宽度
                      data: weeksUsage,
                      itemStyle: {
                  normal: {
                    color: '#dc9b00'
                  }
                }
                  },
                  {
                      name:'实验项目浏览量',
                      type:'bar',
                      barWidth : 15,//柱图宽度
                      data:weeksBrowsing,
                      itemStyle: {
                  normal: {
                    color: '#2267e9'
                  }
                }
                  }
              ]
          };
          usageWeek.hideLoading();
          usageWeek.setOption(usageOption);
        })
      }})
    }
  }
}
</script>

<style lang="scss" scoped>
.video-js {
  width: 100%;
  height: 100%;
}
</style>